// DashboardContext.tsx
import React, { createContext, useContext, ReactNode } from "react";
import { useDashboard } from "@root/hooks/useDashboard";

// type context ke liye (hook ke return type se)
type DashboardContextType = ReturnType<typeof useDashboard>;

// context create
const DashboardContext = createContext<DashboardContextType | undefined>(
  undefined
);

interface DashboardProviderProps {
  children: ReactNode;
}

// Provider component
export const DashboardProvider: React.FC<DashboardProviderProps> = ({
  children,
}) => {
  const dashboard = useDashboard(); // tumhara hook call ho raha hai

  return (
    <DashboardContext.Provider value={dashboard}>
      {children}
    </DashboardContext.Provider>
  );
};

// Custom hook for consuming
export const useDashboardContext = (): DashboardContextType => {
  const context = useContext(DashboardContext);
  if (!context) {
    throw new Error(
      "useDashboardContext must be used within a DashboardProvider"
    );
  }
  return context;
};
